import React from "react";
import cn from "classnames";
import HintIcon from "../../../../shared/icons/HintIcon";
import style from "./OrderActionHint.module.scss";

const OrderActionHint = ({ text, withoutBorder = false }) => {
  if (!text) return null;

  return (
    <div className={cn(style.hint_box, { [style.without_border]: withoutBorder })}>
      <HintIcon />
      <span className={style.hint_text}>{text}</span>
    </div>
  );
};

export default OrderActionHint;
